<template>
<div>
    <el-form ref="anyForm" :model="anyForm" label-width="80px">
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="特價品:">
                    <el-checkbox v-model="anyForm.on_sale" style="width:50%"></el-checkbox>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="折扣期限:" prop="startDate">
                    <el-date-picker v-model="date" type="daterange" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期" unlink-panels></el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="品牌:">
                    <el-radio-group v-model="anyForm.brand_id" @change="classChange">
                        <el-radio :label="1">N牌</el-radio>
                        <el-radio :label="2">S牌</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="系列別:">
                    <el-tag effect="dark" color="#ffafb0" v-if="isShowTag1" style="color:red;border-color: red;">{{this.className}}</el-tag>
                    <el-tag effect="dark" color="#b2fcff" v-if="isShowTag2" style="color:#1089ff;border-color:#1089ff;">{{this.className}}</el-tag>

                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="組合編號:" prop="id">
                    <el-input v-model="anyForm.id" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="組合名稱:" prop="name">
                    <el-input v-model="anyForm.name" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="售價:" prop="price">
                    <el-input v-model.number="anyForm.price" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="任選(項):" prop="choose">
                    <el-input v-model.number="anyForm.choose" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="任搭圖片:">
                    <el-upload ref="upload" action="#" :http-request="uploadFileMethod" accept="image/png,image/gif,image/jpg,image/jpeg" list-type="picture-card" :limit=limitNum :file-list="url" :auto-upload="false" :on-exceed="handleExceed" :before-upload="handleBeforeUpload" :on-preview="handlePictureCardPreview" :on-success="handleSuccess" :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="uploadFile">立即上傳</el-button>

                </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
        </el-row>

        <el-row>
            <el-col :lg="10" :offset="2">
                <el-button type="primary" icon="el-icon-plus" @click="dialogFormVisible = true">新增</el-button>
                <el-dialog title="新增單品" :visible.sync="dialogFormVisible" width="30%" center>
                    <el-form ref="itemsForm" :model="itemsForm" :rules="itemRule" label-width="120px">
                        <el-row>
                            <el-col :lg="18" :offset="6">
                                <el-form-item label="單品編號:" prop="id">
                                  <el-autocomplete popper-class="p-id" v-model="itemsForm.id" class="inline-input" :popper-append-to-body="false" placeholder="請輸入編號"  :fetch-suggestions="queryIdSearch" @select="handleIdSelect">
                                          <template slot-scope="{item}">
                                            <div class="id">{{item.value}} - {{item.name}}</div>
                                            
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="18" :offset="6">
                                <el-form-item label="品牌:">
                                    
                                  {{this.itemForm.brand_id == 1 ? 'N牌':'S牌'}}
                                </el-form-item>
                            </el-col>
                            <el-col :lg="18" :offset="6">
                                <el-form-item label="名稱:">
                                     <el-autocomplete popper-class="p-name" :popper-append-to-body="false" v-model="itemsForm.name" class="inline-input" placeholder="請輸入名稱" :fetch-suggestions="queryNameSearch" @select="handleNameSelect">
                                        <template slot-scope="{item}">
                                            <div class="id">{{item.id}} - {{item.value}}</div>
                                            
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="18" :offset="6">
                                <el-form-item label="價格:" prop="price">
                                    <el-input type="number" v-model.number="itemsForm.price" style="width: 50%;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="18" :offset="6">
                                <el-form-item label="數量:" prop="qty">
                                    <el-input type="number" v-model.number="itemsForm.qty" style="width:50%;"></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>

                        <el-row type="flex" align="center">
                            <el-col :lg="10" :offset="6">
                                <el-button @click="itemBack('itemsForm')">取 消</el-button>
                                <el-button type="primary" @click="addItems('itemsForm')" icon="el-icon-plus">增加</el-button>
                            </el-col>
                        </el-row>
                    </el-form>

                </el-dialog>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
        <el-row>
            <el-col :lg="22" :offset="2">
                <el-table :data="anyForm.items" style="width: 100%">
                    <el-table-column prop="id" label="單品編號">
                    </el-table-column>
                    <el-table-column label="單品名稱" prop="name"></el-table-column>
                    <el-table-column label="價格" prop="price"></el-table-column>
                    <el-table-column label="單位" prop="spec"></el-table-column>
                    <el-table-column label="數量" prop="qty"></el-table-column>
                    <el-table-column label="刪除">
                        <template slot-scope="scope">
                            <el-button type="danger" icon="el-icon-delete" @click.native.prevent="deleteItem(scope.$index, anyForm.items)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="22" :offset="10">
                <el-button type="primary" @click="updateBundle">修改</el-button>
                <el-button type="default" @click="back">返回</el-button>
            </el-col>
        </el-row>

    </el-form>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import moment from 'moment'
export default {
    name: 'addAny',
    props: {
        type: Number,
        productKey: String
    },
    data() {
        return {
            anyForm: {
                on_sale: false,
                class_key: '',
                brand_id: null,
                id: '',
                name: '',
                price: 0,
                images: [],
                items: [],
                type: 3,
                choose: null,
            },
            itemsForm: {
                key: '',
                id: '',
                brand_id: null,
                name: '',
                price: 0,
                qty: 0,
                spec: ''
            },
            resetForm: {
                key: '',
                id: '',
                brand_id: null,
                name: '',
                price: 0,
                qty: 0,
                spec: ''
            },
              itemForm: {
                key: '',
                id: '',
                brand_id: null,
                name: '',
                price: 0,
                qty: 0,
                spec: ''
            },
            rules: {
                id: [{
                    required: true,
                    message: '請輸入任搭編號'
                }],
                name: [{
                    required: true,
                    message: '請輸入任搭名稱'
                }],
                price: [{
                    required: true,
                    message: '請輸入售價'
                }],
                choose: [{
                    required: true,
                    message: '請輸入任選'
                }]
            },
            itemRule: {
                id: [{
                    required: true,
                    message: '請輸入編號',
                    trigger: 'change'
                }],
                price: [{
                    required: true,
                    message: '請輸入價格'
                }],
                qty: [{
                    required: true,
                    message: '請輸入數量'
                }]
            },
            isShowTag1: false,
            isShowTag2: false,
            startDate: [],
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            formLabelWidth: '80px',
            dialogFormVisible: false,
            limitNum: 3,
            products: [],
            bundleItems: [],
            className: '',
            fetchBrandid: null,
            itemBrandId: '',
            classKey: '',
            class: [],
            url: [],
            image: [],
            date: [],
            strEndDate: '',
            strStartDate: '',
            values: [],
        }
    },
    computed: mapGetters(["getProductError", "getProductMsg", "getProductList", "getClassList", "getBundleError", "getBundleMsg", "getFileKey", "getProductDetail", "getImages"]),
    methods: {
        ...mapActions(["fetchProductList", "addBundle", "addBundleFile", "fetchClassList", "fetchProductDetail", "bundleUpdate"]),
        async fetchProduct() {
            const data = {
                _key: this.productKey,
                type: this.type

            }

            this.$store.dispatch('fetchProductDetail', data)
            this.anyForm = this.getProductDetail
            this.date.push(
                this.getProductDetail.on_sale_start,
                this.getProductDetail.on_sale_end
            )
            this.anyForm.items = this.getProductDetail.products
            this.fetchBrandid =this.anyForm.brand_id
            if (this.fetchBrandid == 1) {
                this.itemBrandId = 'N牌'
            }else {
                this.itemBrandId = 'S牌'
            }
           
            this.fetchImages(this.anyForm.images)
        },
        async fetchImages(images) {
            for (let i = 0; i < images.length; i++) {

                const key = await images[i]._key
                await this.$store.dispatch('LoadFile', key)
                let src = await window.URL.createObjectURL(this.getImages)

                this.url.push({
                    _key: images[i]._key,
                    url: src
                })

            }

        },
        async uploadFileMethod(param) {

            let fileObject = param.file;
            let formData = new FormData();
            formData.append("file", fileObject);

            await this.$store.dispatch("addBundleFile", formData)
            this.imageKey = await this.getFileKey
            this.imageUrl = await this.getImageFile
            await this.image.push(
                this.imageKey
            )
        },
        itemBack(formName) {
            this.itemsForm = this.resetForm
            this.dialogFormVisible = false
            this.$refs[formName].resetFields()
            this.$refs[formName].clearValidate()
        },
        addItems(formName) {
            this.anyForm.items.push({
                id: this.itemsForm.id,
                brand_id: this.itemsForm.brand_id,
                name: this.itemsForm.name,
                qty: this.itemsForm.qty,
                price: this.itemsForm.price,
                spec: this.itemsForm.spec,
                product_key: this.itemsForm.key
            })
            this.itemsForm = this.resetForm
            this.dialogFormVisible = false
            this.$refs[formName].resetFields()

        },
     queryNameSearch(queryString, cb) {
            this.fetchNameData(queryString)
            for (let i = 0; i < this.getProductList.length; i++) {
                this.values.push({
                    key: this.getProductList[i]._key,
                    value: this.getProductList[i].name,
                    id: this.getProductList[i].id
                })

            }

            var results = queryString ? this.values.filter(this.createFilter(queryString)) : this.values;
            this.values = [];
            cb(results);

        },
         queryIdSearch(queryString, cb) {
            this.fetchIdData(queryString)
            for (let i = 0; i < this.getProductList.length; i++) {
                this.values.push({
                    key: this.getProductList[i]._key,
                    value: this.getProductList[i].id,
                    name: this.getProductList[i].name
                })

            }

            var results = queryString ? this.values.filter(this.createFilter(queryString)) : this.values;
            this.values = [];
            cb(results);

        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
          async fetchNameData(queryString) {
            const data = await {
                type: 1,
                brand_id: this.itemForm.brand_id,
                name: queryString
            }

            await this.$store.dispatch('fetchProductList', data)
            this.itemForm.brand_id = this.getProductList[0].brand_id
            this.itemForm.name = this.getProductList[0].name
            this.fetchDetail(this.getProductList[0]._key)

        },
        async fetchIdData(queryString) {
            const data = await {
                type: 1,
                brand_id: this.itemForm.brand_id,
                id: queryString
            }

            await this.$store.dispatch('fetchProductList', data)
            this.itemsForm.brand_id = this.getProductList[0].brand_id
            this.itemsForm.id = this.getProductList[0].id
            this.fetchDetail(this.getProductList[0]._key)

        },
        handleNameSelect(item) {
            this.itemsForm.name = item.value
            this.itemsForm.id = item.id
            this.itemsForm.key = item.key
            this.fetchDetail(item.key)
        },
        handleIdSelect(item) {
            this.itemsForm.id = item.value
            this.itemsForm.name = item.name
            this.itemsForm.key = item.key
            this.fetchDetail(item.key)
        },
        async fetchDetail(key) {
            const data = await {
                type: 1,
                _key: key
            }
            await this.$store.dispatch('fetchProductDetail', data)
            this.itemsForm.spec = await this.getProductDetail.spec
            this.itemsForm.key = await key
        },
        async classChange() {
            if (this.anyForm.brand_id == 1 && this.type == 3) {

                this.className = await this.getProductDetail.class.name
                this.isShowTag2 = await false
                this.isShowTag1 = await true
                this.anyForm.class_key = await this.getProductDetail.class._key
            } else if (this.anyForm.brand_id == 2 && this.type == 3) {

                this.className = await this.getProductDetail.class.name
                this.isShowTag1 = await false
                this.isShowTag2 = await true
                this.anyForm.class_key = await this.getProductDetail.class._key
            }
            this.fetchBrandid = this.bundleForm.brand_id
            this.itemsForm.brand_id = this.bundleForm.brand_id
        },

        async updateBundle() {
            for (let i = 0; i < this.url.length; i++) {
                this.image.push(
                    this.url[i]._key
                )
            }
            if (typeof (this.date[0]) != String) {
                this.strStartDate = moment(this.date[0]).format("YYYY-MM-DD")
                this.strEndDate = moment(this.date[1]).format("YYYY-MM-DD")
            } else {
                this.strStartDate = this.date[0]
                this.strEndDate = this.date[1]
            }

            const data = {
                _key: this.anyForm._key,
                id: this.anyForm.id,
                price: this.anyForm.price,
                brand_id: this.anyForm.brand_id,
                class_key: this.anyForm.class_key,
                images: this.image,
                items: this.anyForm.items,
                choose: this.anyForm.choose,
                on_sale: this.anyForm.on_sale,
                name: this.anyForm.name,
                on_sale_start: this.strStartDate,
                on_sale_end: this.strEndDate
            }
            await this.$store.dispatch('bundleUpdate', data)
            if (this.getBundleError != true) {
                this.$notify({
                    title: '成功',
                    message: '修改任搭商品成功',
                    type: 'success',
                    duration: '4500',
                    position: 'top-right'
                });
                this.$emit('back')
            } else {
                this.$notify({
                    title: '失敗',
                    message: this.getBundleMsg,
                    type: 'error',
                    duration: '4500',
                    position: 'top-right'
                });

            }
        },
        deleteItem(index, row) {
            row.splice(index, 1)
        },
        back() {
            this.$emit('back')
        },

        handleBeforeUpload(file) {
            console.log('before')
            if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                this.$notify.warning({
                    title: '警告',
                    message: '請上傳格式為 image/png, image/gif, image/jpg, image/jpeg的圖片'
                })
            }
            let size = file.size / 1024 / 1024 / 2
            if (size > 2) {
                this.$notify.warning({
                    title: '警告',
                    message: '圖片大小必須小於2M'
                })
            }
        },
        // 文件超出个数限制时的钩子
        handleExceed(files, fileList) {

        },
        // 文件列表移除文件时的钩子
        handleRemove(file, fileList) {
            this.url.splice(file, 1)
        },
        // 点击文件列表中已上传的文件时的钩子
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleSuccess(response, file, fileList) {
            this.$notify({
                title: '成功',
                message: '上傳圖片成功',
                type: 'success',
                duration: '4500',
                position: 'top-right'
            });

        },
        uploadFile() {
            this.$refs.upload.submit()
        }
    },
    created() {
        this.fetchProduct()
        this.classChange()

    },
}
</script>

<style lang="scss" scoped >
   /deep/ .p-name  {
      width: 25%!important;
   }
   /deep/ .p-id  {
      width: 25%!important;
   }
     
</style>
